import React from 'react'
import NotFoundBanner from '../../../lib/error-banners/error-404-banner'
import HOME from '../../routing/paths'
import Button from '../../components/Button'

const Error404 = () => {
  return (
    <div className="flex items-center flex-1 flex-col h-full justify-center">
      <NotFoundBanner />
      <div className="flex flex-col items-center">
        <div className="text-gray-700 text-2xl font-bold mb-4">Oops! Page not found</div>
        <Button as="a" href={HOME}>
          Back to home
        </Button>
      </div>
    </div>
  )
}

export default Error404
